// extracted by mini-css-extract-plugin
export default {"container":"LoginNotification_container__lPeOZ","btn":"LoginNotification_btn__0bC79","btnText":"LoginNotification_btnText__g3p2B","btnIcon":"LoginNotification_btnIcon__1wUOJ"};